module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_2-1654af60fb149899e3d7f0630f35b37c.jpg";